<template>
  <div class="everyone">

    <header-bar></header-bar>

    <section class="instructions background-image" v-if="!uiHideInstructions">
      <div class="grid-container">
        <div class="col-4">
          <div class="vertical-align">
            <h3>This is everyone who has signed up to the PEI exChange. Tap to view their profile.</h3>
            <a class="link-simple" @click="hideInstructions">Close</a>
          </div>
        </div>
      </div>
    </section>
    <section class="filter" v-bind:class="{ noinstructions: uiHideInstructions }">
      <div class="grid-container">
<!--         <div class="col-3">
          <div class="select">
            <div class="selected">Ordered Alphabetically</div>
            <div class="select-options">
              <div class="selection-option">
                North Africa
              </div>
              <div class="selection-option">
                Southern Africa
              </div>
              <div class="selection-option">
                East Africa Africa
              </div>
              <div class="selection-option">
                West Africa
              </div>
              <div class="selection-option">
                Central Africa
              </div>
              <div class="selection-option">
                Subsaharan Africa
              </div>
            </div>
          </div>
        </div> -->
        <div class="shift-1 col-4">
          <!-- <input placeholder="Search People..." class="search" type="text" v-model="queryText"> -->
        </div>
      </div>
    </section>

    <section class="matches" v-show="chunkArray">
      <div class="grid-container">

        <user-row v-for="row in chunkArray" :data="row" :key="row"></user-row>

      </div>
    </section>
    

  </div>
</template>

<script>
import { db } from '@/firebase'
import HeaderBar from '@/components/HeaderBar'
import UserRow from '@/components/UserRow'

export default {
  name: 'Matches',
  components: {
    HeaderBar,
    UserRow
  },
  data () {
    return {
      queryText: '',
      results: []
    }
  },
  watch: {
    queryText: function (val) {
      this.results = []
      let term = val.toLowerCase()
      this.$bindAsArray('results', db.ref('users').orderByChild('searchterm').startAt(term).endAt(term + '\uf8ff'))
    }
  },
  created () {
    this.$bindAsArray('results', db.ref('users').orderByChild('searchterm'))
  },
  computed: {
    uiHideInstructions: function () {
      if (this.$root.profile['ui-meta']) {
        if (this.$root.profile['ui-meta'].hideEveryoneInstructions) {
          return true
        }
      } else {
        return false
      }
    },
    userIds: function () {
      let arr = []
      this.results.forEach(function (user) {
        arr.push(user['.key'])
      })
      return arr
    },
    filterUsers: function () {
      let arr = []
      let blockedArr = []
      let blockedObj = this.$root.profile['blocked-users']
      for (let item in blockedObj) {
        blockedArr.push(item)
      }
      this.results.forEach(function (user) {
        let uid = user['.key']
        if (blockedArr.indexOf(uid) > -1) {
          // User is blocked
        } else if (user['firstname'] === undefined) {
          // User is undefined
        } else if (user['disabled']) {
          // User is disabled
        } else {
          arr.push(uid)
        }
      })
      return arr
    },
    chunkArray: function () {
      let chunks = []
      let arr = this.filterUsers
      let i
      let chunkSize = 6
      if (arr) {
        for (i = 0; i < arr.length; i += chunkSize) {
          chunks.push(arr.slice(i, i + chunkSize))
        }
      }
      return chunks
    }
  },
  methods: {
    hideInstructions () {
      db.ref('users/' + this.$root.user.uid + '/ui-meta').update({
        hideEveryoneInstructions: true
      }, function () {
        console.log('hidden the instructions')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Everyone.vue?fa91929c